import { render, staticRenderFns } from "./CGV.vue?vue&type=template&id=3d03cafd&scoped=true"
import script from "./CGV.vue?vue&type=script&lang=js"
export * from "./CGV.vue?vue&type=script&lang=js"
import style0 from "./CGV.vue?vue&type=style&index=0&id=3d03cafd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d03cafd",
  null
  
)

export default component.exports